import styled from 'styled-components'

export const ExampleComponent = styled.div.attrs({
})`
`;

export const PasswordValidationContainer = styled.div.attrs({
})`            
    margin-bottom: 24px;
    ${p => p.row ? `
        display: flex;
        flex-wrap: wrap;
    ` : ``};
`;    